<template>
  <div :id="$style.title">
    <h3>{{ title }}</h3>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "SubTitle",
  props: {
    title: {
      type: String,
      default: "SubTitle"
    },
    color: {
      default: "#3f6b78"
    }
  }
});
</script>

<style lang="scss" module>

@media only screen and (max-width: 1023px){
  #title {
    color: #3f6b78;
    h3 {
      font-size: 20px;
    }
    h2 {
      font-size: 15px;
    }
  }
}

@media only screen and (min-width: 1024px){
  #title {
    color: #3f6b78;
    h3 {
      font-size: 23px;
    }
  }


}

</style>
